export interface UserInfo {
    userName: string;
    connectionId: string;
}


export enum CommandType {
    LOAD = 0,
    PLAY = 1,
    PAUSE = 2,
    SEEK = 3,
    MESSAGE = 4,
    UPDATE_SLIDE = 11,
    UPDATE_CANVAS = 14,
    BEAMER_IS_CONNECTED = 17,
    SEND_SETTINGS_TO_BEAMER = 18,

    ACTIVATE_HOTSPOT = 112,
    NAVIGATE_TO_PREVIEW_SLIDE = 119,
    NAVIGATE_TO_PREVIEW_DRIVERSCAM_ASSIGNMENT = 120,
    SHOW_DIFFICULT_QUESTION_ELEMENT = 121,


    START_LESSON = 20,
    STOP_LESSON = 21,
    UNDO = 25,
    REDO = 26,
    NAVIGATE_TO_PARENT = 29,

    PREFETCH_IMAGES_IN_CHAPTER = 30,
    PREFETCH_EXTENSION_SLIDES = 31,
    PREFETCH_NEXT_BASIC_SLIDES = 32,

    PUSH_THE_BUTTON_COMMAND = 20000,
    PRACTICE_TRAINER_COMMAND = 30000,
}

export interface ClassroomCommand {
    commandType: CommandType;
    commandParam: string;
}
